<template>
    <div>
        <h3 class="font-bold text-base mb-2">
            Redaksjon
        </h3>
        <div>
            <a :href="loginUrl" :target="model.footer.login.target" :title="model.footer.login.title" >
                <font-awesome-icon class="fa-lg" :icon="icon" /><span class="pl-2">{{model.footer.login.text}}</span>
            </a>
        </div>
    </div>
</template>

<script>
import EpiLink from '@/Scripts/components/atoms/EpiLink/index.vue';

export default {
    props: ['model'],
    components: {
        EpiLink
    },
    data() {
        return {
            icon: this.mapIcon(this.model.footer.login.isAuthenticated),
            loginUrl: this.model.footer.login.isAuthenticated ? this.model.footer.login.href : this.model.footer.login.href + '/?language=no#context=epi.cms.contentdata:///' + this.model.contentLink.id,
        };
    },
    methods: {
        mapIcon(isAuthenticated) {
            switch (isAuthenticated) {
                case true:
                    return 'lock-open';
                case false:
                    return 'lock';
            }
        }
    }
};
</script>
